import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters } = createNamespacedHelpers("user");

export default {
  computed: {
    ...mapState(["currentUser"]),
    ...mapGetters([
      "isVendorUser",
      "isClientUser",
      "isAdminUser",
      "hasMonitoringAccess",
      "isAssumingClientRole"
    ])
  }
};
